<template>
  <div>
    <b-card>
      <!-- <swiper class="swiper" :options="swiperOptions"> -->
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide v-for="(item, index) in cards" :key="('item-', +index)"> -->
      <!-- <div
            class="gray-card cursor-pointer"
            @click="handleclick(item.route)"
          > -->
      <!-- <b-card
              :title="item.title"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            > -->
      <!-- <b-card-text class="fsize21px"
                ><b>{{ item.text }}</b>
                <b-button
                  class="btn-p20 ml-10"
                  v-if="item.id === '04'"
                  variant="primary"
                  >withdraw</b-button
                >
              </b-card-text> -->
      <!-- </b-card> -->
      <!-- </div> -->
      <!-- </swiper-slide> -->
      <!-- </swiper> -->
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick('New-order-table')"
          >
            <b-card
              title="New Order"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            >
              <b-card-text class="fsize21px"
                ><b></b>{{ orderCount.pending ? orderCount.pending : 0 }}
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>

        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick('pending-order-table')"
          >
            <b-card
              title="Shipped Order"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            >
              <b-card-text class="fsize21px"
                ><b>{{ orderCount.shipped ? orderCount.shipped : 0 }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick('completed-order-table')"
          >
            <b-card
              title="Completed Order"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            >
              <b-card-text class="fsize21px"
                ><b>{{ orderCount.completed ? orderCount.completed : 0 }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick('total-order-table')"
          >
            <b-card
              title="Total Order"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            >
              <b-card-text class="fsize21px"
                ><b>{{ orderCount.total ? orderCount.total : 0 }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <!-- <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(earningTable)"
          >
            <b-card
              title="Total Earning"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_allbookingcounts.totalEarning
                    ? get_allbookingcounts.totalEarning
                    : 0
                }}</b
                ><b-button class="btn-p20 ml-10" variant="primary"
                  >withdraw</b-button
                >
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide> -->
      </swiper>
    </b-card>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      volunteerTable: "volunteer-table",
      sessionComp: "session-comp",
      careerReq: "career-req",
      earningTable: "earning-table",
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
      },
    };
  },
  methods: {
    async handleclick(route) {
      this.$router.push({ name: route });
    },
    async function() {
      let payload = {
        brandId: this.getVendor.vendor.brandId._id,
      };
      try {
        let loader = this.$loading();

        let data = await this.$store.dispatch(
          "affiliate/getBrandOrder",
          payload
        );
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),

    ...mapState("affiliate", {
      productOrder: "productOrder",
    }),
    ...mapState("affiliate", {
      brandData: "brandData",
      getVendor: "getVendor",
      orderCount: "orderCount",
    }),
  },
  mounted() {
    this.function();
    // console.log(this.orderCount);
  },
};
</script>

<style>
.fsize21px {
  font-size: 21px;
}
.btn-p20 {
  padding: 6px 20px !important;
}
</style>
